import { QueryClient } from '@tanstack/react-query';

import * as queryKeys from '../constants/keys';

/**
 * Both caches the products reporting list can be read from: the plain PM list, and the per-sprint
 * entries the reporting list actually renders (see useSprintPages). Anything that changes a product's
 * numbers has to reach both, or the reporting list keeps showing what it fetched before.
 */
export const invalidatePmProductLists = (queryClient: QueryClient): void => {
  queryClient.invalidateQueries({ queryKey: [queryKeys.PM_PRODUCTS] });
  queryClient.invalidateQueries({ queryKey: [queryKeys.PM_PRODUCTS_BY_SPRINT] });
};
